export function getUserList(params?: any) {
  return request({
    url: '/system/user/getUserList',
    method: 'get',
    params,
  });
}

export function getActiveClientManagerList(params?: any) {
  return request({
    url: '/system/user/getActiveClientManagerList',
    method: 'get',
    params,
  });
}

export function getUserListByRoleKey(data?: any, userName?: string) {
  return request({
    url: '/system/user/getUserByRole',
    method: 'post',
    data,
    params: { name: userName },
  });
}
